import { Notifier } from '@airbrake/browser'
// import { intersection, map } from 'lodash'

var airbrake = new Notifier({
  projectId: 1773,
  projectKey: '36e88dad54f754e13110dbfce213c0d7',
  host: 'https://errbit.enginearch.com',
  environment: process.env.VUE_APP_ENV,
  instrumentation: {
    console: false,
  },
  keysBlocklist: [
    'password', // exact match
    // 'token', // exact match
    /secret/, // regexp match
  ],
  reporter: 'xhr',
  remoteConfig: false,
})
// airbrake.addFilter(function (notice) {
//   if (!['dev', 'staging', 'production'].includes(process.env.VUE_APP_ENV)) {
//     return null
//   }

//   if (
//     intersection(
//       map(notice.errors || [], err => (err || {}).message),
//       [
//         'Request failed with status code 401',
//         'Request failed with status code 403',
//         'Request failed with status code 412',
//         'Request failed with status code 490',
//         'Request failed with status code 491',
//         'Request failed with status code 500',
//         'Request failed with status code 422',
//         'Request failed with status code 409',
//         'Request failed with status code 400',
//         'Request failed with status code 404',
//         'Network Error',
//       ],
//     ).length
//   ) {
//     return null
//   }

//   return notice
// })

window.airbrake = airbrake

export default airbrake

// Airbrake.configure do |config|
//   config.host = 'https://errbit.enginearch.com'
//   config.project_id = 1773 # required, but any positive integer works
//   config.project_key = '36e88dad54f754e13110dbfce213c0d7'

//   config.environment = Rails.env
//   config.ignore_environments = %w[development test]
// end

// Airbrake.add_filter do |notice|
//   if notice[:errors].any? { |error| error[:type] == 'CollectionPointUnit::AvailabilityWorker::NotAvailable' }
//     notice.ignore!
//   end
// end
